import { ROLE } from './acl$';
import { CoordinatorService } from './coordinator.service';
import { ProjectInList } from './project-in-list';
import { User } from './user';
import { ProjectMember } from './project-member';

export class CloudTeamManager {
    private coords: CoordinatorService;

    constructor(private user: User) {
        this.coords = user.coords;
    }

    clear() {}

    get currentRole() {
        return;
        // return this._memberMap.get(`pm-${this.user.id}`)?.role
    }

    async changeTeamOption(pm: ProjectMember, option: string, value: boolean) {
        const projectId = this.coords.project$.currentId;
        const id = `${pm.id}|${projectId}`;
        const resp = await this.coords.firebase$.callFunction('changeTeamOption', {
            teamUserId: id,
            option: option,
            value: value,
        });
        if (pm.isCurrentUser) this.coords.updateAuthClaims();
    }

    async changeTeamRole(pm: ProjectMember, role: ROLE) {
        const projectId = this.coords.project$.currentId;
        const id = `${pm.id}|${projectId}`;
        const resp = await this.coords.firebase$.callFunction('changeRole', {
            teamUserId: id,
            role: role,
        });
        if (pm.isCurrentUser) this.coords.updateAuthClaims();
    }

    private _invitationId(pil: ProjectInList) {
        return `${this.user.id}|${pil.id}`;
    }

    async createInvitation(userId: string, role: ROLE, canAttach = false) {
        // const resp = await this._addTeamMember(userId, role)
        const resp = await this.coords.firebase$.callFunction('invite', {
            projectId: this.coords.project$.currentId,
            userId: userId,
            role: role,
            canAttach: canAttach,
        });
        this.coords.display$.markForCheck();
    }

    async createGroupInvitation(ls: any[]) {
        const resp = await this.coords.firebase$.callFunction('inviteGroup', {
            projectId: this.coords.project$.currentId,
            userLs: ls,
        });
        console.log('createGroupInvitation RESP', resp);
        this.coords.display$.markForCheck();
    }

    async acceptInvitation(pil: ProjectInList) {
        // await this.coords.firebase$.firestore
        //     .updateDocument("teams", this._invitationId(pil), { isPending: false })

        this.coords.display$.openSnackBar(null, {
            message: this.coords.text('AcceptingInvitation'),
        });

        const resp = await this.coords.firebase$.callFunction('teamMember', {
            invitationId: this._invitationId(pil),
            action: 'accept',
        });

        this.coords.display$.closeSnackbar();
        if (resp === 'ERROR') return;
        console.log('ACCEPT INVITATION RESPONSE', resp);
        resp.data && pil.select();
    }

    async rejectInvitation(pil: ProjectInList) {
        // const resp = await this.coords.firebase$.firestore
        //     .deleteDocument("teams", this._invitationId(pil))
        const resp = await this.coords.firebase$.callFunction('teamMember', {
            invitationId: this._invitationId(pil),
            action: 'reject',
        });
        if (resp === 'ERROR') return;
        console.log('DELETE INVITATION RESPONSE', resp);
        resp && this.coords.project$.unsetProjectInList(pil);
    }
}
